import Aos from "aos";
import axios from "axios";
import Footer from "components/Footers/Footer";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import LoadingInfo from "components/LoadingInfo/LoadingInfo";
import { IoIosArrowRoundForward } from "react-icons/io";

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState("");
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("contact-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    Aos.init();
  }, []);

  useEffect(() => {
    axios
      .get("https://eksiogluhukukofisi.pythonanywhere.com/postApi/posts/")
      .then((response) => {
        setPosts(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    console.log(posts);
  }, [posts]);

  const reversedData = [...posts].reverse();

  // Veriyi 3'erli gruplara bölmek için bir yardımcı fonksiyon
  const chunkArray = (array, size) => {
    const chunkedArr = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArr.push(array.slice(i, i + size));
    }
    return chunkedArr;
  };

  // Veriyi 3'erli gruplara böler
  const chunkedData = chunkArray(reversedData, 3);
  console.log(chunkedData);
  return (
    <>
      <Helmet>
        <title>Blog | Ekşioglu Hukuk</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="Blog Yazıları | Ekşioglu Hukuk, EKŞİOĞLU HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
          data-rh="true"
        />
        <link rel="canonical" href="https://www.eksiogluhukukofisi.com/blog" />
        <meta property="og:title" content="Blog Sayfası | Ekşioglu Hukuk" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Blog Yazıları | Ekşioglu Hukuk Ofisi, EKŞİOĞLU HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
        />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/blog"
        />
      </Helmet>
      <div style={{}}>
        <WhiteNavbar />
        <Container>
          <div className="section">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <div className={!isMobile ? "my-6" : "my-5"}>
                  <h1
                    className="font-weight-bold font-sans"
                    style={{
                      background: "linear-gradient(135deg, #0F172A, #333333)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "2.5em",
                      marginBottom: "30px",
                    }}
                  >
                    EKŞİOĞLU HUKUK BLOG YAZILARI
                  </h1>
                </div>
              </Col>
            </Row>
            {loading ? (
              <LoadingInfo />
            ) : (
              chunkedData.map((row, index) => (
                <Row
                  data-aos={index === 0 ? undefined : "fade-up"}
                  data-aos-duration={index === 0 ? undefined : "1000"}
                >
                  {row.map((item) => (
                    <Col key={item.id} md="4">
                      <Card className="bg-white rounded-lg shadow-lg overflow-hidden h-[570px] font-sans">
                        <div className="relative">
                          <a href={`/blog/${item?.slug}`} className="block">
                            <img
                              alt="..."
                              className="w-full h-64 object-cover rounded-t-lg"
                              src={item?.title_image}
                              loading="eager"
                            />
                          </a>
                        </div>
                        <CardBody className="p-4">
                          <CardTitle
                            tag="h2"
                            className="text-2xl font-semibold text-gray-800 min-h-[90px]"
                          >
                            <a
                              href={`/blog/${item?.slug}`}
                              className="bg-gradient-to-r from-gray-800 to-gray-600 text-transparent bg-clip-text line-clamp-3"
                            >
                              {item?.title}
                            </a>
                          </CardTitle>
                          <div className="text-gray-600 text-base mt-3">
                            <p className="line-clamp-3">
                              {item?.short_description}...
                            </p>
                            <div className="mt-2">
                              <a
                                href={`/blog/${item?.slug}`}
                                className="no-underline"
                              >
                                <div className="font-bold text-blue-400 hover:underline hover:text-blue-600">
                                  Devamını Oku
                                  <IoIosArrowRoundForward size={24} />
                                </div>
                              </a>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              ))
            )}
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
